import React from 'react';
import * as DocumentStorageActions from '../../actions/documentStorage';
import { connect } from 'react-redux';

class MenuLayouts extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.onChange = this.onChange.bind(this)
    }

    static get defaultProps() {
        return {
            ConfiguratorManager: {}
        }
    }

    onChange(event) {

        const { dispatch, ConfiguratorManager } = this.props;

        // get update storage
        const updatedStorage = ConfiguratorManager.setDocumentSpecificationIdToStorage(event.target.value);

        dispatch(DocumentStorageActions.updateDocumentStorage(ConfiguratorManager.getStorageId(), null,
            ConfiguratorManager.getDocumentId(), updatedStorage));
    }

    render() {

        const { ConfiguratorManager } = this.props;
        const specificationLabels = ConfiguratorManager.getDocumentSpecificationMultipleLabels();
        const selectedValue = ConfiguratorManager.getStoredDocumentSpecificationId();

        let renderValue = <div />;

        if (specificationLabels.length > 1) {
            renderValue =
                <select defaultValue={ selectedValue } onChange={this.onChange}>
                    {
                        specificationLabels.map(label => {
                            return <option key={label.id} value={label.id}>{label.title}</option>
                        })
                    }
                </select>;
        }

        return renderValue;
    }
}

export default connect(state => ({ configurator: state.configurator }))(MenuLayouts);


// WEBPACK FOOTER //
// ./src/js/components/configuratorElements/MenuLayouts.react.jsx